import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalCompanyDeleteProps {}

const ModalCompanyDelete = ({}: ModalCompanyDeleteProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    invoice: { setInvoice },
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.deleteCompanies');
  const onClose = () => {
    closeSingleModal('deleteCompanies');
    setInvoice('selected.company', -1);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Excluir companhia"
      height={'auto'}
      width={'30vw'}
    >
      <Form.Export.Company.Delete />
    </Modal>
  );
};

export default ModalCompanyDelete;
